import { http } from '@/services/api/client';
import type {
  CreateReportPayload,
  QueryReportsParams,
  ReportPageResult,
  ReportRecord,
  SaveReportDraftPayload,
  UpdateReportPayload,
} from '@/types/report';

export async function fetchReports(params: QueryReportsParams): Promise<ReportPageResult> {
  return http.get('/reports', { params }) as Promise<ReportPageResult>;
}

export async function fetchReport(id: string): Promise<ReportRecord> {
  return http.get(`/reports/${id}`) as Promise<ReportRecord>;
}

export async function saveReportDraft(payload: SaveReportDraftPayload): Promise<ReportRecord> {
  return http.post('/reports/draft', payload) as Promise<ReportRecord>;
}

export async function createReport(payload: CreateReportPayload): Promise<ReportRecord> {
  return http.post('/reports', payload) as Promise<ReportRecord>;
}

export async function updateReport(id: string, payload: UpdateReportPayload): Promise<ReportRecord> {
  return http.patch(`/reports/${id}`, payload) as Promise<ReportRecord>;
}

export async function deleteReport(id: string): Promise<{ success: true }> {
  return http.delete(`/reports/${id}`) as Promise<{ success: true }>;
}
